// UserContext.js
import { createContext, useContext } from 'react'

export const UserContext = createContext({
  userInfo: null,
  setUserInfo: () => {}
})

export const useUser = () => useContext(UserContext)
